import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import AppProvider from './AppProvider';

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('for-ant-man')
);
